<template>
  <div id="app">
    <div class="popup no-constrain">
      <PuP/>
    </div>
  </div>
</template>

<script>
import PuP from './components/pup'

export default {
  name: 'App',
  components: {
    PuP
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.popup {
    background: #fff;
    border: 1px solid #333;
    max-width: 1024px;
    min-width: 660px;
    position: fixed;
    left: 50%;
    display: block;
    border-radius: 4px;
    -webkit-box-shadow: 0 2px 3px 0 rgba(0,0,0,.3);
    box-shadow: 0 2px 3px 0 rgba(0,0,0,.3);
}

.popup.no-constrain {
    max-width: 1024px;
    width: 100%;
    transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
}

</style>



// WEBPACK FOOTER //
// src/App.vue